import type { TranslationMessages } from '../../types';

export const profile: TranslationMessages = {
  title: 'Hồ sơ của tôi',
  subtitle: 'Xem và quản lý thông tin hồ sơ cá nhân của bạn',
  user_not_found: 'Không tìm thấy người dùng',
  profile_created: 'Hồ sơ nhân viên đã được tạo thành công',
  profile_create_failed: 'Không thể tạo hồ sơ của bạn',
  profile_load_failed: 'Không thể tải hồ sơ của bạn',
  profile_deleted: 'Hồ sơ nhân viên đã được xóa thành công',
  duplicate_profiles_warning:
    'Cảnh báo: Tìm thấy nhiều hồ sơ cho người dùng này. Đang cập nhật hồ sơ gần đây nhất.',
  duplicate_profiles_detected:
    'Cảnh báo: Tìm thấy nhiều hồ sơ. Vui lòng liên hệ quản trị viên để hợp nhất chúng.',
  duplicate_profiles_error:
    'Lỗi: Người dùng có nhiều hồ sơ. Chỉ cho phép 1 hồ sơ cho mỗi người dùng. Vui lòng liên hệ quản trị viên.',
  profile_delete_failed: 'Không thể xóa hồ sơ nhân viên',
  retry: 'Thử lại',
  total_staff: 'Tổng số nhân viên',
  active_staff_members: 'Thành viên nhân viên đang hoạt động',
  department: 'Phòng ban',
  your_department: 'Phòng ban của bạn',
  position: 'Vị trí',
  your_position: 'Vị trí của bạn',
  avg_rate: 'Tỷ lệ trung bình',
  average_hourly_rate: 'Mức lương trung bình theo giờ',
  personal_information: 'Thông tin cá nhân',
  user_id: 'ID người dùng',
  address: 'Địa chỉ',
  gender: 'Giới tính',
  not_specified: 'Không xác định',
  professional_information: 'Thông tin chuyên môn',
  department_id: 'ID phòng ban',
  not_assigned: 'Chưa được giao',
  position_id: 'ID vị trí',
  hourly_rate: 'Mức lương theo giờ',
  no_profile_found: 'Không tìm thấy hồ sơ',
  profile_not_available: 'Thông tin hồ sơ nhân viên của bạn không có sẵn.',
  personal_info: 'Thông tin cá nhân',
  hire_date: 'Ngày thuê',
  edit_profile: 'Chỉnh sửa hồ sơ nhân viên',
  edit_profile_description:
    'Cập nhật thông tin hồ sơ nhân viên bao gồm loại hình việc làm và lương thưởng',
  profile_updated: 'Hồ sơ nhân viên đã được cập nhật thành công',
  profile_update_failed: 'Không thể cập nhật hồ sơ nhân viên',
  basic_information: 'Thông tin cơ bản',
  address_placeholder: 'Nhập địa chỉ',
  gender_placeholder: 'Nhập giới tính',
  position_id_placeholder: 'Nhập ID vị trí',
  department_id_placeholder: 'Nhập ID phòng ban',
  employment_information: 'Thông tin việc làm',
  employment_type: 'Loại hình việc làm',
  part_time: 'Bán thời gian',
  full_time: 'Toàn thời gian',
  contract: 'Hợp đồng',
  full_time_settings: 'Cài đặt toàn thời gian',
  vacation_days_per_year: 'Ngày nghỉ phép mỗi năm',
  vacation_days_used: 'Ngày nghỉ phép đã sử dụng',
  base_salary: 'Lương cơ bản (Tùy chọn)',
  base_salary_hint: 'Lương cơ bản hàng tháng nếu có',
  guaranteed_hours: 'Giờ làm việc đảm bảo mỗi tuần',
  guaranteed_hours_hint: 'Số giờ tối thiểu được đảm bảo mỗi tuần',
  compensation: 'Lương thưởng',
  rate_per_hour: 'Mức lương mỗi giờ',
  currency: 'Tiền tệ',
  user_id_required: 'ID người dùng là bắt buộc để tạo hồ sơ',
  current_points: 'Điểm hiện tại',
  total_earned: 'Tổng kiếm được',
  total_spent: 'Tổng đã chi tiêu',
  earned_badges: 'Huy hiệu đã kiếm được',
  badge_collection: 'Bộ sưu tập huy hiệu',
  no_badges: 'Chưa kiếm được huy hiệu nào',
};
